export default __webpack_public_path__ + "f5370348988a63c689728b393e3523ab.svg";